import React from 'react';
import withAuthorization from '../../hoc/withAuthorization';
import LargePaper from '../../components/Layout/LargePaper';
import stylesDefault from '../../constants/stylesDefault';
import LldSitesSelect from '../../components/LldSitesSelect/LldSitesSelect';
import LldRentTabs from '../../components/LldRent/LldRentTabs';

const RentLLDPage = () => {
  return (
    <LargePaper>
      <h1 style={stylesDefault.title}>Location longue durée</h1>
      <LldSitesSelect />
      <LldRentTabs />
    </LargePaper>
  );
}

const authCondition = authUser => !!authUser;

export default withAuthorization(authCondition)(RentLLDPage);



// WEBPACK FOOTER //
// ./src/containers/RentLLDPage/RentLLDPage.jsx